import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import React from "react";
import CreateBulkTrip from "src/views/manage-trip/CreateBulkTrip";

const BulkAssignTrip = ({
  bulkTripId,
  setBulkTripId,
  priority,
  country,
  handleCloseModal,
}) => {
  return (
    <CModal
      scrollable
      backdrop="static"
      alignment="center"
      size="xl"
      visible={!!bulkTripId}
      onClose={handleCloseModal}
      aria-labelledby="StaticBackdropExampleLabel"
    >
      <CModalHeader>
        <CModalTitle id="StaticBackdropExampleLabel">
          Create New Trip
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CreateBulkTrip
          id={bulkTripId}
          priority={priority}
          country={country}
          handleCloseModal={handleCloseModal}
        />
      </CModalBody>
    </CModal>
  );
};

export default BulkAssignTrip;
